<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetIndowSteps from '$lib/PageSections/GetIndowSteps/GetIndowSteps.svelte';

	import residentialImage from './images/above_sink_installation.jpg?w=500';

	let {
		title = 'Indow For Your Windows',
		backgroundColor = 'blue',
		id = '',
		image = residentialImage,
	} = $props();
</script>

<Section {backgroundColor} {id}>
	<GetIndowSteps {title} />

	<Button class="mb-12" href="/free-estimate">GET A FREE ESTIMATE</Button>

	{#if image}
		<Image
			src={image}
			loading="lazy"
			class="no-bleed mb-4 max-w-xl rounded-lg shadow-lg"
		/>
	{/if}
	<p class="max-w-xl text-left text-indow-grey-dark">
		We value safety and privacy. We will never share, sell, or rent your data to
		third parties not directly related to your purchase or consideration of our
		products. <a class="text-indow-grey-medium" href="/privacy-policy"
			>Read our full policy here.</a
		>
	</p>
</Section>
